import fitvid from './_fitvid';

class FeaturedVideo {
	constructor(node) {
		this.node = node;
		this.link = this.node.querySelector('a');
		this.embedded = false;

		this.template = this.node.querySelector('.featured-media__player > script');
		if (this.template) {
			this.link.addEventListener('click', this.show.bind(this));
		}
	}

	show(e) {
		if (this.embedded) {
			return;
		}
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		this.node.classList.add('featured-media--video-active');
		this.template.parentNode.insertAdjacentHTML('beforeend', this.template.innerHTML);
		fitvid();
		this.embedded = true;
		this.link.removeEventListener('click', this.show.bind(this));
	}
}

export default FeaturedVideo;